import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import {
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Page,
  PageSettingsModel,
  Resize,
  Sort,
  Inject,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import {
  AnimationSettingsModel,
  ButtonPropsModel,
  DialogComponent,
} from '@syncfusion/ej2-react-popups';
import * as React from 'react';
import {all_information, GetErpTypeFromConfig, loadingShow} from '../../App';
import Message from '../../utils/Message/Message';
import './style.css';
import {
  AddPlan,
  DeletePlan,
  DeletePlanOrder,
  EditPlan,
  getOrderByPlan,
  getPlan,
} from '../../services/ControlCenter/PlanServices';
import GlobalPlannedOrderGrid from '../../components/GlobalPlannedOrderGrid';
import { SwitchComponent } from '@syncfusion/ej2-react-buttons';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
interface IProps {
  event_id: number;
}


const toolbarOptionsOrder = [
 /*  {
    text: 'Assign Work Orders',
    tooltipText: 'Add',
    prefixIcon: 'e-add',
    id: 'add',
  }, */
  // {
  //   text: 'Navigate to Kanban',
  //   tooltipText: 'navigate',
  //   prefixIcon: 'e-arrow',
  //   id: 'navigate',
  // },
  /* {
    text: 'Delete',
    tooltipText: 'Delete',
    prefixIcon: 'e-delete',
    id: 'delete',
  }, */
  'Search',
];
const FilterOptions: FilterSettingsModel = { type: 'Menu' };
const pageOptions: PageSettingsModel = {
  currentPage: 1,
  pageSize: 50,
  pageCount: 10,
  pageSizes: false,
};
var buttons: ButtonPropsModel[];
let gridControlCenterPlanObj: GridComponent;
let gridPlanOrder: GridComponent;
let txtPlanName = '';
let txtPlanDescription = '';
let isEdit = false;
let planID = -1;
let status: boolean = false;
const animationSettings: AnimationSettingsModel = {
  effect: 'Zoom',
  duration: 400,
  delay: 0,
};
gridPlanOrder = new GridComponent({});
gridControlCenterPlanObj = new GridComponent({});
const toolbarOptions: any = [
  {
    text: 'Add',
    tooltipText: 'Add',
    prefixIcon: 'e-add',
    id: 'add',
  },
  {
    text: 'Edit',
    tooltipText: 'Edit',
    prefixIcon: 'e-edit',
    id: 'edit',
  },
  {
    text: 'Delete',
    tooltipText: 'Delete',
    prefixIcon: 'e-delete',
    id: 'delete',
  },
  {
    text: 'Approve',
    tooltipText: 'Approve',
    prefixIcon: 'e-save',
    id: 'approve',
  },
  'Search',
];
const Plan = ({ event_id }: IProps) => {
  let ERP_TYPE =  useSelector((state: any) => state.search.ERP_TYPE);
  const erpTypeName = 'MEX';
  let timezone_offset = useSelector(
    (state: any) => state.search.timezone_offset
  );
  const [planData, setPlanData] = React.useState<Array<any>>([]);
  const [planOrderData, setPlanOrderData] = React.useState<Array<any>>([]);
  const [hideDialog, setHideDialog] = React.useState<boolean>(false);
  const [hideDialogOrder, setHideDialogOrder] = React.useState<boolean>(false);
  const [dtStartDate, setDtStartDate] = React.useState<Date>(
    new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
  );
  const [dtEndDate, setDtEndDate] = React.useState<Date>(
    new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1)
  );
  buttons = [
    {
      click: () => {
        savePoint();
      },
      buttonModel: {
        content: 'Save',
        isPrimary: true,
      },
    },
    {
      click: () => setHideDialog(false),
      buttonModel: {
        content: 'Close',
      },
    },
  ];

  const getPlanOrder = async (plan_id: any) => {
    await getOrderByPlan(
      `1$500$ {"f":"ID","c":"=","t":"where","v":"${plan_id}"}`,
      timezone_offset
    )
      .then((res) => {
        let model = res.data.map((items: any) => {
          return {
            ...items,
            organization_code: all_information.companyName,
            order_code: items.order_code,
            ID: items.plan_order_id,
            comesFromPlan: true,
          };
        });
        loadingShow(false);
        setPlanOrderData(model);
      })
      .catch((error) => {
        console.log(error);
        loadingShow(false);
      });
  };
  const getThePlan = (id: number) => {
    getPlan(id === -1 ? '' : id).then((result) => {
      let planOrder = result.data.length > 0 ? planOrderData : [];
      setPlanData(result.data);
      setPlanOrderData(planOrder);
    });
  };
  const savePoint = () => {
    const sDate = new Date(dtStartDate).getTime();
    const eDate = new Date(dtEndDate).getTime();

    if (txtPlanName === '') {
      Message.error('Can not be empty plan name');
      return false;
    }
    if (txtPlanDescription === '') {
      Message.error('Can not be empty description');
      return false;
    }
    if (sDate === 0) {
      Message.error('Can not be empty start date');
      return false;
    }
    if (eDate === 0) {
      Message.error('Can not be empty end date');
      return false;
    }
    loadingShow(true);
    const obj: any = {
      organization_Id: all_information.company_id?.toString(),
      plan_name: txtPlanName,
      plan_description: txtPlanDescription,
      planned_start_date: new Date(dtStartDate),
      planned_end_date: new Date(dtEndDate),
      created_by: all_information.user_id,
      event_code: '',
      event_id: event_id,
      ID: planID,
      status: status,
    };
    //(obj);

    if (!isEdit) {
      delete obj.ID;
      AddPlan(obj)
        .then((res: any) => {
          Message.success('Success');
          loadingShow(false);
          getThePlan(event_id);
          closeDialog();
        })
        .catch((err: any) => {
          if (err.response) {
            Message.error(
              err.response.data +
                '\n' +
                err.response.status +
                '\n' +
                err.response.headers
            );
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
          loadingShow(false);
        });
    } else {
      EditPlan(obj)
        .then((res: any) => {
          Message.success('Success');
          loadingShow(false);
          getThePlan(event_id);
          closeDialog();
        })
        .catch((err: any) => {
          if (err.response) {
            Message.error(
              err.response.data +
                '\n' +
                err.response.status +
                '\n' +
                err.response.headers
            );
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
          loadingShow(false);
        });
    }
  };
  const deletePoint = (obj: any) => {
    DeletePlan(obj)
      .then((res: any) => {
        Message.success('Success');
        loadingShow(false);
        getThePlan(event_id);
        closeDialog();
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  };
  const toolbarClick = (args: any) => {
    if (args.item.id === 'add') {
      if (event_id !== -1) {
        cleanForInput();
        isEdit = false;
        planID = -1;
        status = false;
        setHideDialog(true);
      } else {
        Message.error('no records selected for event');
      }
    }
    if (args.item.id === 'edit') {
      if (gridControlCenterPlanObj.getSelectedRecords().length !== 0) {
        const data = gridControlCenterPlanObj.getSelectedRecords()[0] as any;
        isEdit = true;
        planID = data.ID;
        txtPlanName = data.plan_name;
        txtPlanDescription = data.plan_description;
        status = data.status;
        setHideDialog(true);
        setDtStartDate(new Date(data.planned_start_date));
        setDtEndDate(new Date(data.planned_end_date));
      } else {
        Message.error('no records selected for plan');
      }
    }
    if (args.item.id === 'delete') {
      if (gridControlCenterPlanObj.getSelectedRecords().length !== 0) {
        const data = gridControlCenterPlanObj.getSelectedRecords()[0] as any;
        const obj = {
          ID: data.ID,
        };
        deletePoint(obj);
      } else {
        Message.error('no records selected for plan');
      }
    }
    if (args.item.id === 'approve') {
      if (gridControlCenterPlanObj.getSelectedRecords().length !== 0) {
        const data = gridControlCenterPlanObj.getSelectedRecords()[0] as any;
        isEdit = true;
        planID = data.ID;
        txtPlanName = data.plan_name;
        txtPlanDescription = data.plan_description;
        setDtStartDate(new Date(data.planned_start_date));
        setDtEndDate(new Date(data.planned_end_date));
        SaveApprovePlan();
      } else {
        Message.error('no records selected for plan');
      }
    }
  };
  const toolbarClickOrder = async (args: any) => {
    if (args.item.id === 'add') {
      if (gridControlCenterPlanObj.getSelectedRecords().length !== 0) {
        setHideDialogOrder(true);
      } else {
        Message.error('No records selected for plan');
      }
    }
    if (args.item.id === 'edit') {
      if (gridPlanOrder.getSelectedRecords().length !== 0) {
        setHideDialogOrder(true);
      } else {
        Message.error('No records selected for Order');
      }
    }
    if (args.item.id === 'delete') {
      if (gridPlanOrder.getSelectedRecords().length !== 0) {
        if (gridPlanOrder.getSelectedRecords().length !== 0) {
          const plan = gridControlCenterPlanObj.getSelectedRecords()[0] as any;
          const data = gridPlanOrder.getSelectedRecords() as any;
          let CompanyID = all_information.company_id?.toString();
          let created_by = all_information.user_id;
          let plan_id = plan.ID;
          let obj = data.map((el: any) => {
            return {
              ...el,
              order_id: el.order_id,
              organization_Id: CompanyID,
              created_by: created_by,
              plan_id: plan_id,
            };
          });
          loadingShow(true);
          deleteOrderPlan(obj, plan_id, true);
          // deletePoint(obj);
        } else {
          Message.error('no records selected for order');
        }
      } else {
        Message.error('No records selected to delete');
      }
    }
    // if (args.item.id === 'navigate') {
    //   if (gridControlCenterPlanObj.getSelectedRecords().length !== 0) {
    //     const data =
    //       gridControlCenterPlanObj.getSelectedRecords()[0] as any;
    //     context.setPlanId(data.ID);
    //     props.navigation('/cloudplanner');
    //   } else {
    //     Message.error('No records selected to navigate');
    //   }
    // }
  };
  const deleteOrderPlan = async (
    obj: any,
    plan_id: number,
    fetchData: boolean
  ) => {
    await DeletePlanOrder(obj)
      .then((res: any) => {
        Message.success('Success');
        if (fetchData) {
          getPlanOrder(plan_id);
        }
        loadingShow(false);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  };
  const closeDialog = () => {
    cleanForInput();
    setHideDialog(false);
  };
  const cleanForInput = () => {
    txtPlanName = '';
    txtPlanDescription = '';
    setDtStartDate(
      new Date(new Date().getFullYear(), new Date().getMonth(), 1)
    );
    setDtEndDate(
      new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
    );
    setHideDialog(false);
  };
  const rowSelectPlan = async (args: any) => {
    let selRecord: any = args.data;
    planID = selRecord.ID;
    loadingShow(true, 'Please wait.');
    await getPlanOrder(selRecord.ID);
  };
  const SaveApprovePlan = () => {
    const obj = JSON.stringify({
      organization_Id: all_information.company_id?.toString(),
      plan_name: txtPlanName,
      plan_description: txtPlanDescription,
      planned_start_date: new Date(dtStartDate),
      planned_end_date: new Date(dtEndDate),
      created_by: all_information.user_id,
      event_id: event_id,
      event_code: '',
      status: true,
      ID: planID,
    });
    EditPlan(obj)
      .then((res: any) => {
        Message.success('Success');
        loadingShow(false);
        getThePlan(event_id);
        closeDialog();
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  };
  const templateStatusPlan = (args: any) => {
    return (
      <div>
        {!args.status || args.status === null ? (
          <span>Waiting for Approve</span>
        ) : (
          <span>Ready for Scheduling</span>
        )}
      </div>
    );
  };
  useEffect(() => {
    if (event_id === -1) {
      return
    }
    const getData = async () => {
      await getThePlan(event_id);
    };
    getData();
    return () => { };
  }, []);
  useEffect(() => {
    if (event_id === -1) {
      return
    }
    getThePlan(event_id);
  }, [event_id]);

  return (
    <div className='control-center-plan'>
      <div className='plan-grid-1'>
        <GridComponent
          id='gridEventPlan'
          dataSource={planData}
          toolbar={toolbarOptions}
          ref={(g: GridComponent) => (gridControlCenterPlanObj = g)}
          filterSettings={FilterOptions}
          allowFiltering={true}
          allowPaging={true}
          pageSettings={pageOptions}
          toolbarClick={toolbarClick.bind(this)}
          showColumnMenu={true}
          allowResizing={true}
          style={{ marginTop: '10px' }}
          gridLines='Both'
          rowSelected={rowSelectPlan.bind(this)}
          width='calc(100% - 8px)'
          height='30vh'
        >
          <ColumnsDirective>
            <ColumnDirective
              field='ID'
              headerText='Plan ID'
              width='100'
              textAlign='Left'
              isPrimaryKey={true}
              type='number'
            />
            <ColumnDirective
              field='plan_name'
              headerText='Plan Name'
              type='string'
            />
            <ColumnDirective
              field='plan_description'
              headerText='Plan Description'
              type='string'
            />
            <ColumnDirective
              field='planned_start_date'
              headerText='Planned Start Date'
              format='dd/MM/yyyy'
              type='date'
            />
            <ColumnDirective
              field='planned_end_date'
              headerText='Planned End Date'
              format='dd/MM/yyyy'
              type='date'
            />
            <ColumnDirective
              field='status'
              template={templateStatusPlan.bind(this)}
              headerText='Status'
              type='string'
            />
          </ColumnsDirective>
          <Inject
            services={[Toolbar, Page, Resize, Filter, Sort, ColumnMenu]}
          />
        </GridComponent>
      </div>
      <div id='plan-grid-2'>
        <GridComponent
          id='gridPlansdfsdfsdfwewed'
          dataSource={planOrderData}
          toolbar={toolbarOptionsOrder}
          ref={(g: GridComponent) => (gridPlanOrder = g)}
          filterSettings={FilterOptions}
          allowFiltering={true}
          allowPaging={true}
          pageSettings={pageOptions}
          showColumnMenu={true}
          allowResizing={true}
          style={{ marginTop: '10px' }}
          toolbarClick={toolbarClickOrder.bind(this)}
          gridLines='Both'
          width={'calc(100% - 8px)'}
          height='30vh'
        >
          <ColumnsDirective>
            <ColumnDirective type='checkbox' headerText='#' width={35} />
            <ColumnDirective
              field='plan_name'
              headerText='Plan Name'
              visible={false}
              type='string'
            />
            <ColumnDirective
              field='organizationId'
              headerText='Organization Code'
              width={50}
              type='string'
              visible={false}
            />
            <ColumnDirective
              type='string'
              field='priority_code'
              headerText='Priority Code'
            />
            <ColumnDirective
              field='asset_code_parent'
              headerText='Parent Asset'
              type='string'
              visible={ERP_TYPE === erpTypeName ? true : false}
            />

            <ColumnDirective
              field='asset_code'
              headerText='Asset Code'
              type='string'
            />
            <ColumnDirective
              field='asset_description'
              headerText='Asset Description'
              type='string'
              visible={ERP_TYPE === erpTypeName ? true : false}
            />
            {/* <ColumnDirective
              field='description'
              headerText='WO Description'
              type='string'
            /> */}
            <ColumnDirective
              field='order_code'
              headerText='Order Code'
              type='string'
            />
            <ColumnDirective
              field='description'
              headerText='WO Description'
              type='string'
              visible={ERP_TYPE === erpTypeName ? true : false}
            />
            <ColumnDirective
              field='status_code'
              headerText='Status Code'
              type='string'
            />
            <ColumnDirective
              field='type_code'
              headerText='Type Code'
              type='string'
            />
            <ColumnDirective
              field='scheduled_start_date'
              headerText='Schedule Start Date'
              type='date'
              visible={ERP_TYPE === erpTypeName ? true : false}
              format='dd/MM/yyyy HH:mm'
            />
            <ColumnDirective
              field='scheduled_end_date'
              headerText='Schedule End Date'
              type='date'
              visible={ERP_TYPE === erpTypeName ? true : false}
              format='dd/MM/yyyy HH:mm'
            />
            {/* <ColumnDirective
              field='type_code'
              headerText='Schedule Duration'
              visible={ERP_TYPE === erpTypeName ? true : false}
            /> */}

            <ColumnDirective
              field='planned_start_date'
              headerText='Planned Start Date'
              format='dd/MM/yyyy HH:mm'
              type='date'
            />
            <ColumnDirective
              field='planned_end_date'
              headerText='Planned End Date'
              format='dd/MM/yyyy HH:mm'
              type='date'
            />
            {/* <ColumnDirective
              field='type_code'
              headerText='Planned Duration'
              visible={ERP_TYPE === erpTypeName ? true : false}
            /> */}

            {/* <ColumnDirective
              type='string'
              field='priority_code'
              headerText='Priority Code'
            /> */}
            <ColumnDirective
              type='string'
              field='order_resp_code'
              headerText='Responsibility'
              visible={ERP_TYPE === erpTypeName ? false : true}
            />
            <ColumnDirective
              field='actualStartDate'
              headerText='Actual Start Date'
              format='dd/MM/yyyy HH:mm'
              type='date'
            />
            <ColumnDirective
              field='actualEndDate'
              headerText='Actual End Date'
              format='dd/MM/yyyy HH:mm'
              type='date'
            />
            <ColumnDirective
              field='site_details_1'
              headerText='Reference'
              type='string'
              visible={ERP_TYPE === erpTypeName ? true : false}
            />
            <ColumnDirective
              field='creation_date'
              headerText='Created Date'
              format='dd/MM/yyyy HH:mm'
              type='date'
              visible={ERP_TYPE === erpTypeName ? true : false}
            />
            <ColumnDirective
              field='created_by'
              headerText='Created By'
              type='string'
              visible={ERP_TYPE === erpTypeName ? true : false}
            />
            <ColumnDirective
              field='order_branch'
              headerText='Account Code'
              type='string'
              visible={ERP_TYPE === erpTypeName ? true : false}
            />
            <ColumnDirective
              field='wo_labour_cost'
              headerText='Labour Cost'
              format='C2'
              type='string'
              visible={ERP_TYPE === erpTypeName ? true : false}
            />
            <ColumnDirective
              field='wo_material_cost'
              headerText='Material Cost'
              type='string'
              visible={ERP_TYPE === erpTypeName ? true : false}
              format='C2'
            />
            <ColumnDirective
              field='wo_other_cost'
              headerText='Other Cost'
              type='string'
              visible={ERP_TYPE === erpTypeName ? true : false}
              format='C2'
            />
            <ColumnDirective
              field='pm_schedule_id'
              headerText='PM Task'
              type='string'
            />
            <ColumnDirective
              field='team_code'
              headerText='Team'
              type='string'
              visible={ERP_TYPE === erpTypeName ? false : true}
            />
            <ColumnDirective
              field='shift'
              headerText='Shift'
              type='string'
              visible={ERP_TYPE === erpTypeName ? false : true}
            />
            <ColumnDirective
              field='order_section_code'
              headerText='Section'
              type='string'
              visible={ERP_TYPE === erpTypeName ? false : true}
            />
            <ColumnDirective
              field='order_branch'
              headerText='Branch'
              type='string'
              visible={ERP_TYPE === erpTypeName ? false : true}
            />
          </ColumnsDirective>
          <Inject
            services={[Toolbar, Page, Resize, Filter, Sort, ColumnMenu]}
          />
        </GridComponent>
      </div>
      <div className='popup-control-center-plan'>
        <DialogComponent
          isModal={true}
          id='defaultdialogControlCenterPlan'
          showCloseIcon={true}
          animationSettings={animationSettings}
          visible={hideDialog}
          width={'600px'}
          height={'450px'}
          header='Plan'
          buttons={buttons}
          open={() => setHideDialog(true)}
          close={closeDialog.bind(this)}
        >
          <div className='plan-input-controlcenter'>
            <div className='input-group-plan'>
              <div className='col-md-12'>
                <TextBoxComponent
                  placeholder='Plan Name'
                  value={txtPlanName}
                  floatLabelType='Always'
                  onChange={(e: any) => {
                    txtPlanName = e.target.value;
                  }}
                />
              </div>
            </div>
            <div className='input-group-plan'>
              <div className='col-md-12'>
                <TextBoxComponent
                  placeholder='Plan Description'
                  floatLabelType='Always'
                  id='planDesc'
                  value={txtPlanDescription}
                  onChange={(e: any) => {
                    txtPlanDescription = e.target.value;
                  }}
                />
              </div>
            </div>
            <div className='input-group-plan'>
              <div className='col-md-12'>
                <DatePickerComponent
                  id='planSDate'
                  floatLabelType='Always'
                  placeholder='Plan Start Date'
                  value={dtStartDate}
                  format='dd/MM/yyyy'
                  onChange={(e: any) => {
                    setDtStartDate(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className='input-group-plan'>
              <div className='col-md-12'>
                <DatePickerComponent
                  placeholder='Plan End Date'
                  id='planEDate'
                  floatLabelType='Always'
                  value={dtEndDate}
                  format='dd/MM/yyyy'
                  onChange={(e: any) => {
                    setDtEndDate(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className='col-md-12'>Status</div>
            <div className='input-group-plan'>
              <div className='col-md-12'>
                <SwitchComponent
                  change={(e: any) => {
                    status = e.checked;
                  }}
                  checked={status}
                />
              </div>
            </div>
          </div>
        </DialogComponent>
      </div>
      <div className='popup-control-center-plan'>
        {hideDialogOrder ? (
          <GlobalPlannedOrderGrid
          
            hideDialogOrder={hideDialogOrder}
            setHideDialogOrder={(val: boolean) => setHideDialogOrder(val)}
            getPlanOrder={getPlanOrder.bind(this)}
            plan_id={planID}
          />
        ) : null}
      </div>
    </div>
  );
};
export default Plan;
